import { PosixDate } from "../../time/posix-date.js";
export function posixDateField(opts) {
    return (value) => {
        if (opts.required && value === undefined)
            return {
                isValid: false,
                error: opts.message,
            };
        if (value == undefined) {
            return {
                isValid: true,
                value: undefined,
            };
        }
        if (!(value instanceof PosixDate)) {
            return {
                isValid: false,
                error: opts.message,
            };
        }
        return {
            isValid: true,
            value,
        };
    };
}
